const Link = {
  baseStyle: {
    transition: 'all 0.15s linear',
    color: 'link.500',
    _hover: { textDecoration: 'none', color: 'link.500' },
  },
};

export default Link;
